module.exports = __webpack_public_path__ + "static/media/dart.20d7b829.svg";